import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

import MeetingDetailModal from '../../components/meeting/MeetingDetailModal';

/**
 * Route wrapper for the meeting detail modal, so a direct link/deep link to
 * /meeting-summary/:eventId still works. The actual UI is a modal
 * (MeetingDetailModal), not a full page -- closing it goes back to
 * wherever the user came from.
 */
const MeetingSummaryPage = () => {
  const { eventId } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const isManual = searchParams.get('manual') === 'true';

  return (
    <MeetingDetailModal
      eventId={eventId}
      isManual={isManual}
      onClose={() => navigate(-1)}
    />
  );
};

export default MeetingSummaryPage;
